module.exports = __webpack_public_path__ + "img/20210906-1630912427458108.d07e404e.png";